export default function NoDataMessage({ message = "Aucune donnée" }: { message?: string }) {
  return (
    <div style={{ padding: "20px 0" }}>
      <p style={{ textAlign: "center", fontSize: "16px" }}>{message}</p>
    </div>
  );
}
